// import { post } from "components/Axios";
import { post } from "../Axios/Axios";
import { sha256 } from "js-sha256";
// import { randomString } from "./commonService";


export function randomString(){
    const length = 100;
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
  };

export function LoginUser(username, password, callback) {
  // Hashing the password
  const salt = randomString();
  const hashedPassword = sha256.hmac(salt, password);

  let req = {
    username: username,
    password: hashedPassword,
    password2: salt,
  };

  post("/login", req, 0).then((res) => {
    if (res) {
      callback(res);
    } else {
      callback({
        status: false,
        message: "Invalid username or Password",
      });
    }
  });
}


export function LoginDepartmentUser(username, password, callback) {
  // Hashing the password
  const salt = randomString();
  const hashedPassword = sha256.hmac(salt, password);


  let req = {
    username: username,
    password: hashedPassword,
    password2: salt,
    // userType:1,
  };

  post("/login", req, 0).then((res) => {
    if (res) {
      callback(res);
    } else {
      callback({
        status: false,
        message: "Invalid username or Password",
      });
    }
  });
}

